import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { SnackbarProvider } from 'notistack'
import { MotionConfig } from 'framer-motion'
import { store } from '@app/store'
import { AppThemeProvider } from '@theme/AppThemeProvider'
import { AppRoutes } from '@routes/index'
import { AppErrorBoundary } from '@components/AppErrorBoundary'

export const App = () => (
  <AppErrorBoundary>
    <Provider store={store}>
      <AppThemeProvider>
        <MotionConfig reducedMotion="user">
          <SnackbarProvider
            maxSnack={3}
            autoHideDuration={3500}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          >
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
          </SnackbarProvider>
        </MotionConfig>
      </AppThemeProvider>
    </Provider>
  </AppErrorBoundary>
)
